import Tab from './Tab'
export default Tab
export * from './Tab'
